<script>
export default {
    name: "SkokkaCarouselSlide",
}
</script>

<template>
    <div class="carousel-slide">
        <slot></slot>
    </div>
</template>